import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationRU from './locales/ru/translation.json';

const resources = {
  en: { translation: translationEN },
  ru: { translation: translationRU }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ru',
    supportedLngs: ['ru', 'en'],
    detection: {
      // ?lang=ru / ?lang=en wins over everything — the hreflang URLs in
      // index.html and sitemap.xml point at these params, so they have to work.
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false
    }
  });

// Keep <html lang> in sync with the language actually rendered, otherwise a
// crawler on Accept-Language: en-US gets English text under lang="ru".
const syncHtmlLang = (lng) => {
  if (typeof document === 'undefined') return;
  const resolved = (lng || i18n.resolvedLanguage || 'ru').split('-')[0];
  document.documentElement.setAttribute('lang', resolved);
};

syncHtmlLang(i18n.resolvedLanguage);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
